// extracted by mini-css-extract-plugin
export default {"isSaved":"XP6hB___AddToSavedItemsButton-module__isSaved"};